export function capitalizeOnlyFirstLetter(
  input: string | null | undefined,
): string {
  if (input) {
    return input.charAt(0).toUpperCase() + input.slice(1);
  }
  return "";
}
